module.exports = __webpack_public_path__ + "img/logo-company.a49006a3.png";